import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,
    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    ActivityIndicator,
    Text,
    PermissionsAndroid,
    Linking, I18nManager,
    Image,
    RefreshControl
} from "react-native";


import {scale, moderateScale, verticalScale} from '../../../../tools/Scaling';


import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";


import i18n from '../../../../I18n/i18n.js';

const SLIDER_1_FIRST_ITEM = 1;

import * as  NavigationService from "../../../../redux/NavigationService";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMTextView from "../../../../customviews/HMTextView";
import Colors, {colorDark, colorPrimary} from "../../../../tools/Colors";

import {typeExport} from "../../../../redux/store/type";

import HMLoading from "../../../../customviews/HMLoading";

import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";

import connect from "react-redux/es/connect/connect";
import EmptyView from "../../../../customviews/empty/EmptyView";
import axios from "axios";
import HMIcon from "../../../../customviews/HMIcon";
import store from "../../../../redux/store";
import SliderContainer from "../../../../customviews/seekbar/SliderContainer";
import {SeekBar} from "../../../../customviews/seekbar";
import HMModal from "../../../../customviews/modal/HMModal";

let container = null
let checkScreenRegister = null;
let Phone = null;
let MoarefRef = null;

class ListServiceSatiaScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        let params = props.route && props.route.params;
        checkScreenRegister = params ? (params.type && params.type === "register") : (props.itemExtra.type && props.itemExtra.type === "register");
        Phone = props.route && props.route.params?.Phone;
        MoarefRef = props.route && props.route.params?.MoarefRef;
        //   let item = props.route.params ? props.route.params.item : null

        // let listGroup = props.DataSplashSatiaScreen.results.listGroup;

        // let Services = props.DataSplashSatiaScreen.user.customer.services;

        // let list = item ? ListGroup.filter(function (entry) {
        //     return entry.SpeedClass === item.speed;
        // }) : []
        //let myService = null;
        // for (let i = 0; i < Services.length; i++) {
        //     let f = Services[i].Active;
        //     if (f == 1)
        //         myService = (Services[i]);
        // }

        // listGroup = listGroup ? listGroup : [];

        // let finalMyService = null;
        //  myService = Services.find(obj => obj.Active == 1)
        //myService = props.myService;
        /*  if (myService) {

              let group = listGroup.find(obj => obj.ServiceGroup == myService.ServiceGroup)

              if (group) {
                  let service = group.services.find(obj => obj.Speed == myService.SpeedClass)
                  if (service) {
                      finalMyService = service.list.find(obj => obj.Serial == myService.Serial)
                  }
              }
              else {
                  finalMyService = myService
              }

          }*/
        let {item, myService, ServicesReserve} = props.route && props.route.params ? props.route.params : {}
        this.state = {
            myService: myService,
            //myService: finalMyService,
            ServicesReserve: ServicesReserve,
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            indexSelectType: 0,
            indexSelectTypeServicesGroup: 0,
            listFilterParent: [],
            listFilter: [],
            //list: ListGroup,
            list: [],
            visibleModal: false,
            // list: [
            //     {
            //         id: 1,
            //         name: 'سرویس لاله یک مگ (1ماهه)(12گیگ بین الملل معادل48گیگ داخلی)(سطح برنزی)',
            //         image: 'http://partak.satiaisp.com/images/speeds/512.png',
            //         // image_source: PathFile.image.sabt_darkhast,
            //         typeClick: 1,
            //         duration: "1 ماه",
            //         Period: "1",
            //         CostPerMonth: "350,000 ريال",
            //         SubscriptionFee: "350,000 ريال",
            //         Discount: 0, Tax: "2,000 ریال", subscription: "1,000 ریال",
            //         SumPrice: "392,000 ریال",
            //     },
            //     {
            //         id: 2,
            //         name: 'سرویس زنبق یک مگ (1ماهه)(20گیگ بین الملل معادل 80 گیگ داخلی )(سطح نقره ای)',
            //         image: 'http://partak.satiaisp.com/images/speeds/1024.png',
            //         // image_source: PathFile.image.sabt_darkhast,
            //         typeClick: 2,
            //         duration: "1 ماه",
            //         Period: "1",
            //         CostPerMonth: "437,000 ريال",
            //         SubscriptionFee: "437,000 ريال",
            //         Discount: 0, Tax: "2,000 ریال", subscription: "1,000 ریال",
            //         SumPrice: "487,230 ریال",
            //     },
            //     {
            //         id: 3,
            //         name: 'سرویس لاله یک مگ (3ماهه)(36گیگ بین الملل معادل 144گیگ داخلی)(سطح برنزی)',
            //         image: 'http://partak.satiaisp.com/images/speeds/2048.png',
            //         // image_source: PathFile.image.sabt_darkhast,
            //         typeClick: 3,
            //         duration: "3 ماه",
            //         Period: "3",
            //         CostPerMonth: "315,000 ريال",
            //         SubscriptionFee: "945,000 ريال",
            //         Discount: 0, Tax: "2,000 ریال", subscription: "1,000 ریال",
            //         SumPrice: "1,062,750 ریال",
            //     },
            //     {
            //         id: 4,
            //         name: 'سرویس زنبق یک مگ (3ماهه)(60گیگ بین الملل معادل 240 گیگ داخلی )(سطح نقره ای)',
            //         image: 'http://partak.satiaisp.com/images/speeds/3072.png',
            //         // image_source: PathFile.image.sabt_darkhast,
            //         typeClick: 4,
            //         duration: "3 ماه",
            //         Period: "3",
            //         CostPerMonth: "393,300 ريال",
            //         SubscriptionFee: "1,179,900 ريال",
            //         Discount: 0, Tax: "2,000 ریال", subscription: "1,000 ریال",
            //         SumPrice: "2,011,050 ریال",
            //     },
            //     {
            //         id: 5,
            //         name: 'سرویس لاله یک مگ (6ماهه)(72گیگ بین الملل معادل 288گیگ داخلی)(سطح برنزی)',
            //         image: 'http://partak.satiaisp.com/images/speeds/4096.png',
            //         // image_source: PathFile.image.sabt_darkhast,
            //         typeClick: 5,
            //         duration: "6 ماه",
            //         Period: "6",
            //
            //         CostPerMonth: "371,450 ريال",
            //         SubscriptionFee: "2,228,700 ريال",
            //         Discount: 0, Tax: "2,000 ریال", subscription: "1,000 ریال",
            //         SumPrice: "2,494,683 ریال",
            //     },
            //     {
            //         id: 6,
            //         name: 'سرویس زنبق یک مگ (6ماهه)(120گیگ بین الملل 480 گیگ داخلی)(سطح نقره ای)',
            //         image: 'http://partak.satiaisp.com/images/speeds/8192.png',
            //         // image_source: PathFile.image.sabt_darkhast,
            //         typeClick: 6,
            //         duration: "6 ماه",
            //         Period: "6",
            //
            //         CostPerMonth: "280,000 ريال",
            //         SubscriptionFee: "3,360,000 ريال",
            //         Discount: 0, Tax: "2,000 ریال", subscription: "1,000 ریال",
            //         SumPrice: "3,793,200 ریال",
            //     },
            //     {
            //         id: 7,
            //         name: 'سرویس لاله یک مگ (یکساله)(144گیگ بین الملل معادل 576گیگ داخلی)(سطح برنزی)',
            //         image: 'http://partak.satiaisp.com/images/speeds/16384.png',
            //         // image_source: PathFile.image.sabt_darkhast,
            //         typeClick: 7,
            //         duration: "یکساله",
            //         Period: "12",
            //
            //         CostPerMonth: "349,600 ريال",
            //         SubscriptionFee: "4,195,200 ريال",
            //         Discount: 0, Tax: "2,000 ریال", subscription: "1,000 ریال",
            //         SumPrice: "4,703,568 ریال",
            //     },
            //     {
            //         id: 7,
            //         name: 'سرویس زنبق یک مگ (یکساله)(240گیگ بین الملل معادل 960 گیگ داخلی )(سطح نقره ای)',
            //         image: 'http://partak.satiaisp.com/images/speeds/16384.png',
            //         // image_source: PathFile.image.sabt_darkhast,
            //         typeClick: 7,
            //         duration: "یکساله",
            //         Period: "12",
            //
            //         CostPerMonth: "350,000 ريال",
            //         SubscriptionFee: "350,000 ريال",
            //         Discount: 0, Tax: "2,000 ریال", subscription: "1,000 ریال",
            //         SumPrice: "45,000 ریال",
            //     },
            //
            // ],

        };

        // props.callServiceRefresh();


    }

    componentDidMount() {

        // if (store.getState().reducerSplashGetAllData.TypeLogin == 2)
        this.getData()

    }


    getData() {

        this.setState({
            //ShowImage:true
            isLoading: true,
            NoInternetDialog: false,

        })


        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('token', this.props.token);
        formData.append('customer', this.props.DataSplashSatiaScreen.Account ? JSON.stringify(this.props.DataSplashSatiaScreen.Account) : null);

//    InternetType: this.state.resultCheckPhone && this.state.resultCheckPhone.Type ? this.state.resultCheckPhone.Type : "A",
//                                 Township: this.state.resultCheckPhone && this.state.resultCheckPhone.Type ? this.state.resultCheckPhone.Type : "1",
//                                 SerialMdfGroup: this.state.resultCheckPhone && this.state.resultCheckPhone.TownshipRef ? this.state.resultCheckPhone.TownshipRef : "1",
//                                 CustomerGroup: "1",
        if (checkScreenRegister) {
            let {InternetType, Township, SerialMdfGroup, CustomerGroup, resultCheckPhone} = this.props.route && this.props.route.params ? this.props.route.params : this.props.itemExtra
            formData.append('resultCheckPhone', JSON.stringify(resultCheckPhone));
            formData.append('InternetType', InternetType);
            formData.append('Township', Township);
            formData.append('SerialMdfGroup', SerialMdfGroup);
            formData.append('CustomerGroup', CustomerGroup);
            formData.append('typeRegister', true);

        }

        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT_FILE
            }
        };
        axios({
            method: 'post',
            url: typeExport._baseUrlSatia + "services/customerServices",
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //  axios.post(typeExport._baseUrlSatia + "services/customerServices", formData, config)
            .then(async response => {
                let data = response.data;
                let list = response.data.result && response.data.result.data ? response.data.result.data : response.data.result;


                // data.status ? this.state.listImage.push(image) : null;

                this.setState({
                    //ShowImage:true
                    list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.status,

                })
            }).catch((e) => {

            this.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
            console.log('error', e)
        })
    }

    componentWillReceiveProps(props) {
        // console.log("props", props)
    }

    render() {
        // let {} = this.props.route.params
        // let list = this.props.DataSplashSatiaScreen.results.services.filter( ({ SpeedClass }) =>  SpeedClass == '256' )
        // let list = this.props.DataSplashSatiaScreen.results.services.filter(function (entry) {
        //     return entry.SpeedClass === item.speed;
        // })
        let item = this.props.route && this.props.route.params ? this.props.route.params.item : null;
        let checkLogin = (store.getState().reducerSplashSatiaScreen.token)


        return (
            <View style={item ? {position: 'relative', flex: 1} : {flex: 1}}>


                <View style={item ? {position: 'absolute', top: 0, bottom: 0, left: 0, right: 0} : {
                    width: "100%",
                    height: "100%"
                }}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        {
                            item ?
                                <HMActionBarSatia
                                    menu={checkLogin}
                                    back
                                    props={this.props} statusBarTransparent
                                    //  text={i18n.t('Apply.title')}
                                    text={item ? (item.name ? item.name : (item.title ? item.title : '')) : null}
                                    //   text={i18n.t('constant.Information')}

                                    headerVisibility more_menu
                                    onBackPress={() => this.props.navigation.pop()}

                                />
                                :
                                null
                        }


                        <View style={{flex: 1}}>
                            {

                                this.state.ServicesReserve ?
                                    <View
                                        style={{
                                           // flex: 1,
                                              width: '99%',
                                            // height: moderateScale(30),
                                            flexDirection: 'row',
                                            borderRadius: moderateScale(4),

                                            backgroundColor: Colors.warning,
                                            margin: moderateScale(4),
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            alignSelf: 'center',
                                            paddingVertical: moderateScale(8),
                                            borderWidth: moderateScale(1),
                                            borderColor: Colors.colorPrimary,
                                            padding: moderateScale(10),

                                        }}>

                                        <HMTextView
                                            text={"به دليل اينکه حساب کاربري شما دارای بسته رزرو می باشد ، شما امکان خريد سرویس را نداريد !"}
                                            // text={"dfhgdfgdfgdf"}
                                            type={"bold"}
                                            style={{
                                                //textAlign: "center",
                                                color: Colors.colorDarkText,
                                                fontSize: moderateScale(14)

                                            }}
                                            styleRoot={{flex: 1, flexWrap: "wrap"}}

                                        />


                                    </View>
                                    :
                                    null


                            }
                            <ScrollView
                                refreshControl={
                                    <RefreshControl
                                        refreshing={this.state.isLoading}
                                        onRefresh={() => this.getData()}

                                    />
                                }

                            >
                                <View style={{flex: 1}}>
                                    <View style={{flexDirection: "row", width: "100%",}}>
                                        {/*           <TouchableOpacity
                                            onPress={() => {
                                                this.setState({visibleModal: true})

                                            }}
                                            style={{
                                                //width: '96%',
                                                padding: moderateScale(6),
                                                height: moderateScale(33),
                                                backgroundColor: Colors.colorSecondPrimary,
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                //  alignSelf: 'center',
                                                flexDirection: 'row',
                                                marginVertical: moderateScale(4),
                                                marginHorizontal: moderateScale(4),
                                                borderRadius: moderateScale(8)
                                            }}>

                                            <HMIcon
                                                type={"Feather"}

                                                name={"filter"}
                                                style={{
                                                    fontSize: moderateScale(20),
                                                    color: Colors.white,
                                                    textAlign: "center",
                                                    padding: moderateScale(4),

                                                }}/>
                                            {
                                                1 === 1 ?
                                                    <HMTextView
                                                        numberOfLines={1}
                                                        type={"bold"}
                                                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                        text={`( 1 )`}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            color: Colors.white,
                                                            //  marginHorizontal: moderateScale(4)
                                                            //  marginTop: moderateScale(4),
                                                            //  textAlign: "right",
                                                        }}/>
                                                    :
                                                    null
                                            }

                                            <HMTextView
                                                numberOfLines={1}
                                                type={"bold"}
                                                // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                text={"فیلتر"}
                                                style={{
                                                    fontSize: moderateScale(14),
                                                    color: Colors.white,
                                                    marginHorizontal: moderateScale(4)
                                                    //  marginTop: moderateScale(4),
                                                    //  textAlign: "right",
                                                }}/>


                                        </TouchableOpacity>*/}
                                        {
                                            this.state.myService && !this.state.ServicesReserve ?
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        NavigationService.navigateParams(MoarefRef ? "PaySatiaScreen_Root" : "PaySatiaScreen", {
                                                            item: this.state.myService

                                                            //     {
                                                            //     id: 7,
                                                            //     name: 'سرویس زنبق یک مگ (یکساله)(240گیگ بین الملل معادل 960 گیگ داخلی )(سطح نقره ای)',
                                                            //     image: 'http://partak.satiaisp.com/images/speeds/16384.png',
                                                            //     // image_source: PathFile.image.sabt_darkhast,
                                                            //     typeClick: 7,
                                                            //     duration: "یکساله",
                                                            //     Period: "12",
                                                            //
                                                            //     CostPerMonth: "350,000 ريال",
                                                            //     SubscriptionFee: "350,000 ريال",
                                                            //     Discount: 0, Tax: "2,000 ریال", subscription: "1,000 ریال",
                                                            //     SumPrice: "45,000 ریال",
                                                            // }
                                                        })

                                                    }}
                                                    style={{
                                                        //width: '96%',
                                                        padding: moderateScale(6),
                                                        height: moderateScale(33),
                                                        backgroundColor: Colors.colorSecondPrimary,
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        alignSelf: 'center',
                                                        flexDirection: 'row',
                                                        marginVertical: moderateScale(4),
                                                        marginHorizontal: moderateScale(4),
                                                        borderRadius: moderateScale(8)
                                                    }}>

                                                    <HMIcon name={"reload"}
                                                            style={{
                                                                fontSize: moderateScale(20),
                                                                color: Colors.white,
                                                                textAlign: "center",
                                                                padding: moderateScale(4),

                                                            }}/>
                                                    {/*<Image*/}
                                                    {/*source={PathFile.image.Check}*/}
                                                    {/*//resizeMode="stretch"*/}
                                                    {/*style={[{}, {*/}


                                                    {/*// position: 'absolute',*/}
                                                    {/*//  bottom: 0,*/}
                                                    {/*width: moderateScale(15),*/}
                                                    {/*height: moderateScale(15),*/}
                                                    {/*tintColor: Colors.white*/}
                                                    {/*// alignSelf: 'center',*/}
                                                    {/*}]}/>*/}
                                                    <HMTextView
                                                        numberOfLines={1}
                                                        type={"bold"}
                                                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                        text={"تمدید سرویس فعلی"}
                                                        style={{
                                                            fontSize: moderateScale(14),
                                                            color: Colors.white,
                                                            marginHorizontal: moderateScale(4)
                                                            //  marginTop: moderateScale(4),
                                                            //  textAlign: "right",
                                                        }}/>

                                                    <HMTextView
                                                        numberOfLines={1}
                                                        type={"bold"}
                                                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                        //text={`    ${this.state.myService.SumPrice} ریال `}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            color: Colors.white,
                                                            marginHorizontal: moderateScale(4)
                                                            //  marginTop: moderateScale(4),
                                                            //  textAlign: "right",
                                                        }}/>


                                                </TouchableOpacity>
                                                :
                                                null
                                        }


                                    </View>

                                    {
                                        this.props.results == null && this.props.isLoading ?
                                            <HMLoading/>

                                            :

                                            <View style={{width: "99%", alignSelf: 'center'}}>
                                                <FlatList
                                                    style={{marginTop: moderateScale(1)}}
                                                    // ItemSeparatorComponent={
                                                    //     <View style={{
                                                    //         width: '100%',
                                                    //         height: moderateScale(1),
                                                    //         backgroundColor: '#4f4f4f'
                                                    //     }}/>
                                                    // }
                                                    // data={comment === null || !comment ? [] : comment}
                                                    //     numColumns={1}
                                                    //type => 1=  , 2= , 3= , 4= ,
                                                    // data={this.state.indexSelectType === 0 && this.state.indexSelectTypeServicesGroup === 0 ? this.state.list : this.state.listFilter}
                                                    data={this.state.list}
                                                    //data={list}
                                                    //  refreshing={this.state.isLoading}
                                                    // onRefresh={() => this.getData()}
                                                    renderItem={this.renderItems}
                                                    initialNumToRender={typeExport._Count - 1}
                                                    onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                                    getItemLayout={(data, index) => (
                                                        {length: 40, offset: 40 * index, index}
                                                    )}
                                                    keyExtractor={(item, index) => index.toString()}
                                                />
                                                <EmptyView
                                                    empty={this.state.indexSelectType === 0 && this.state.indexSelectTypeServicesGroup === 0 ? this.state.list && this.state.list.length === 0 : this.state.listFilter && this.state.listFilter.length === 0}/>
                                            </View>

                                    }
                                </View>
                            </ScrollView>
                            {
                                this.state.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }


                            {
                                this.state.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                            }


                            {
                                <HMModal
                                    isVisible={this.state.visibleModal}
                                    //visible={this.state.visibleModal}
                                    backdropColor={Colors.gray}
                                    backdropOpacity={0.8}
                                    animationIn="zoomInDown"
                                    animationOut="zoomOutUp"
                                    animationInTiming={600}
                                    animationOutTiming={600}
                                    backdropTransitionInTiming={600}
                                    backdropTransitionOutTiming={600}
                                    //style={{height: '60%'}}
                                    onBackdropPress={() => this.hiddenModal()}
                                    onBackButtonPress={() => this.hiddenModal()}

                                    animationType="slide"
                                    // transparent={true}
                                >

                                    <View style={[Platform.OS === 'web' ? {width: "90%",} : {},
                                        {

                                            padding: moderateScale(16),
                                            backgroundColor: Colors.white,
                                            border: moderateScale(4),

                                        }]}>

                                        <ScrollView
                                            style={{
                                                width: '100%'

                                            }}
                                            ref={scroll => this._scroll = scroll}
                                            keyboardShouldPersistTaps="handled"
                                        >
                                            <View
                                                style={{flex: 1,}}
                                            >
                                                <View style={{width: moderateScale(200)}}>
                                                    <SliderContainer
                                                        caption="محدوده قیمت"
                                                        type={"price"}
                                                        sliderValue={[1000, 100000000]}>
                                                        <SeekBar
                                                            animateTransitions
                                                            maximumTrackTintColor="#d3d3d3"
                                                            maximumValue={100000000}
                                                            minimumTrackTintColor="#1fb28a"
                                                            minimumValue={1000}
                                                            step={500}
                                                            thumbTintColor="#1a9274"
                                                            onSlidingComplete={(e) => {
                                                            }}
                                                        />
                                                    </SliderContainer>
                                                </View>
                                                <View style={{width: moderateScale(200)}}>
                                                    <SliderContainer
                                                        caption="محدوده مدت"

                                                        sliderValue={[1, 12]}>
                                                        <SeekBar
                                                            animateTransitions
                                                            maximumTrackTintColor="#d3d3d3"
                                                            maximumValue={12}
                                                            minimumTrackTintColor="#1fb28a"
                                                            minimumValue={1}
                                                            step={1}
                                                            thumbTintColor="#1a9274"
                                                            onSlidingComplete={(e) => {
                                                            }}
                                                        />
                                                    </SliderContainer>
                                                </View>
                                            </View>
                                        </ScrollView>
                                    </View>
                                </HMModal>
                            }

                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    hiddenModal() {
        this.setState({
                visibleModal: false
            },
            () => {
            })
    }

    renderItems = ({item, index}) => {
        let unitValue = this.props.DataSplashSatiaScreen.unitValue ? this.props.DataSplashSatiaScreen.unitValue : 10;
        let unit = this.props.DataSplashSatiaScreen.unit ? this.props.DataSplashSatiaScreen.unit : "تومان";
        return <View
            onPress={() => {
                // duration:"1 ماه",
                //     CostPerMonth:200000,
                //     SubscriptionFee:210000,
                //     Discount:0,
                //     SumPrice:245000,


                //NavigationService.navigateParams("PaySatiaScreen", {item})

            }}
            style={{
                // width: typeExport.WIDTH - moderateScale(8),

                width: '100%',
                //  flex:1,
                // height: typeExport.WIDTH / 2,
                marginBottom: moderateScale(4),
                borderRadius: moderateScale(6),
                borderColor: '#dfe7ee',
                backgroundColor: Colors.white,
                borderWidth: moderateScale(1),
                overflow: 'hidden',

                //  marginVertical: moderateScale(2),
                // padding: moderateScale(6)
            }}>
            {/*       <View
                style={{
                    flex: 1,
                    width: '100%',

                    // alignItems: 'center',
                    // justifyContent: 'center',
                    //     flexDirection:'row',
                }}>
                <View style={{flex: 1, padding: moderateScale(6)}}>
                    <HMTextView
                        numberOfLines={2}
                        type={"bold"}
                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                        text={item.name}
                        style={{
                            fontSize: moderateScale(12),

                            color: Colors.blackLight,
                            //  marginTop: moderateScale(4),
                            //  textAlign: "right",
                        }}/>

                    <View style={{flex: 1, flexDirection: 'row', justifyContent: 'space-between'}}>
                        <HMTextView
                            numberOfLines={1}
                            type={"bold"}
                            // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                            text={"مدت اعتبار" + " : "}
                            style={{
                                fontSize: moderateScale(12),
                                color: Colors.colorDark,
                                // marginTop: moderateScale(4),
                                //  textAlign: "right",
                            }}/>

                        <HMTextView
                            numberOfLines={1}
                            type={"bold"}
                            // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                            text={item.duration}
                            style={{
                                fontSize: moderateScale(12),
                                color: Colors.colorDark,
                                //  marginTop: moderateScale(4),
                                //  textAlign: "right",
                            }}/>


                    </View>
                    <View style={{flex: 1, flexDirection: 'row', justifyContent: 'space-between'}}>
                        <HMTextView
                            numberOfLines={1}
                            type={"bold"}
                            // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                            text={"هزینه هر ماه" + " : "}
                            style={{
                                fontSize: moderateScale(12),
                                color: Colors.colorDark,
                                // marginTop: moderateScale(4),
                                //  textAlign: "right",
                            }}/>

                        <HMTextView
                            numberOfLines={1}
                            type={"bold"}
                            // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                            text={item.CostPerMonth}
                            style={{
                                fontSize: moderateScale(12),
                                color: Colors.colorDark,
                                //  marginTop: moderateScale(4),
                                //  textAlign: "right",
                            }}/>


                    </View>
                    {!item.SubscriptionFee || item.SubscriptionFee == 0 ? null :
                        <View style={{flex: 1, flexDirection: 'row', justifyContent: 'space-between'}}>
                            <HMTextView
                                numberOfLines={1}
                                type={"bold"}
                                // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                text={"هزینه اشتراک" + " : "}
                                style={{
                                    fontSize: moderateScale(12),
                                    color: Colors.yellow,
                                    // marginTop: moderateScale(4),
                                    //  textAlign: "right",
                                }}/>

                            <HMTextView
                                numberOfLines={1}
                                type={"bold"}
                                // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                text={item.SubscriptionFee}
                                style={{
                                    fontSize: moderateScale(12),
                                    color: Colors.yellow,
                                    //  marginTop: moderateScale(4),
                                    //  textAlign: "right",
                                }}/>


                        </View>
                    }
                    {!item.Discount || item.Discount == 0 ? null :
                        <View style={{flex: 1, flexDirection: 'row', justifyContent: 'space-between'}}>
                            <HMTextView
                                numberOfLines={1}
                                type={"bold"}
                                // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                text={"تخفیف" + " : "}
                                style={{
                                    fontSize: moderateScale(12),
                                    color: Colors.red,
                                    // marginTop: moderateScale(4),
                                    //  textAlign: "right",
                                }}/>

                            <HMTextView
                                numberOfLines={1}
                                type={"bold"}
                                // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                text={item.Discount}
                                style={{
                                    fontSize: moderateScale(12),
                                    color: Colors.red,
                                    //  marginTop: moderateScale(4),
                                    //  textAlign: "right",
                                }}/>


                        </View>
                    }
                    <View style={{flex: 1, flexDirection: 'row', justifyContent: 'space-between'}}>
                    <HMTextView
                    numberOfLines={1}
                    type={"bold"}
                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                    text={"هزینه سرویس + مالیات" + " : "}
                    style={{
                    fontSize: moderateScale(12),
                    color: Colors.green,
                    // marginTop: moderateScale(4),
                    //  textAlign: "right",
                    }}/>

                    <HMTextView
                    numberOfLines={1}
                    type={"bold"}
                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                    text={item.SumPrice}
                    style={{
                    fontSize: moderateScale(12),
                    color: Colors.green,
                    //  marginTop: moderateScale(4),
                    //  textAlign: "right",
                    }}/>


                    </View>
                </View>
                <View
                    style={{
                        width: '100%',
                        height: moderateScale(33),
                        backgroundColor: Colors.colorSecondPrimary,
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'row'
                    }}>
                    <Icon name="md-cart" style={{
                        //   width: moderateScale(15),
                        // height: moderateScale(15),
                        color: Colors.white,
                        fontSize: moderateScale(24),
                        padding: moderateScale(4),
                        alignSelf: "center",
                    }}/>
                    <Image
                    source={PathFile.image.Check}
                    //resizeMode="stretch"
                    style={[{}, {


                    // position: 'absolute',
                    //  bottom: 0,
                    width: moderateScale(15),
                    height: moderateScale(15),
                    tintColor: Colors.white
                    // alignSelf: 'center',
                    }]}/>
                    <HMTextView
                        numberOfLines={1}
                        type={"bold"}
                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                        // text={"فعال سازی این طرح"}
                        text={item.SumPrice + " ریال "}
                        cammas
                        style={{
                            fontSize: moderateScale(16),
                            color: Colors.white,
                            marginHorizontal: moderateScale(4)
                            //  marginTop: moderateScale(4),
                            //  textAlign: "right",
                        }}/>


                </View>

            </View>
*/}

            <View>
                <View style={{flex: 1, width: '100%', flexDirection: 'row'}}>

                    <Image
                        source={{uri: item.Image ? item.Image : item.image}}
                        //resizeMode="stretch"
                        style={[{}, {
                            width: moderateScale(40),
                            height: moderateScale(50),
                            //    tintColor: Colors.white
                        }]}
                    />

                    <View>
                        <HMTextView
                            numberOfLines={2}
                            type={"bold"}
                            // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                            text={item.Name}
                            style={{
                                fontSize: moderateScale(14),

                                color: Colors.blue,
                                //  marginTop: moderateScale(4),
                                //  textAlign: "right",
                            }}/>
                        <HMTextView
                            numberOfLines={2}
                            type={"bold"}
                            // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                            text={item.Comment}
                            style={{
                                fontSize: moderateScale(14),

                                color: Colors.colorDarkText,
                                //  marginTop: moderateScale(4),
                                //  textAlign: "right",
                            }}/>

                    </View>
                </View>
                <FlatList
                    style={{marginTop: moderateScale(1)}}
                    keyExtractor={(item, index) => index.toString()}

                    // ItemSeparatorComponent={
                    //     <View style={{
                    //         width: '100%',
                    //         height: moderateScale(1),
                    //         backgroundColor: '#4f4f4f'
                    //     }}/>
                    // }
                    // data={comment === null || !comment ? [] : comment}
                    //numColumns={2}
                    //type => 1=  , 2= , 3= , 4= ,
                    data={item.services}
                    //data={list}
                    renderItem={({item: itemSub, index: indexSub}) => {


                        return <View

                            style={{
                                width: '96%',
//flex:1,
                                alignSelf: 'center',
                                //  width: '100%',
                                //  flex:1,
                                //  height: typeExport.WIDTH / 2,
                                marginBottom: moderateScale(4),
                                borderRadius: moderateScale(6),
                                borderColor: this.state.ServicesReserve ? Colors.gray : "#dae0f2",
                                backgroundColor: "#fbfbfb",
                                borderWidth: moderateScale(1),
                                overflow: 'hidden',
                                marginVertical: moderateScale(3),
                                //  marginVertical: moderateScale(2),
                                // padding: moderateScale(6)
                            }}>
                            <View style={{padding: moderateScale(4)}}>
                                <View style={{flexDirection: 'row'}}>

                                    <View
                                        style={[{}, {


                                            // position: 'absolute',
                                            //  bottom: 0,
                                            width: moderateScale(20),
                                            height: moderateScale(20),
                                            //  tintColor: Colors.white
                                            // alignSelf: 'center',
                                        }]}
                                    >
                                        {/*<Image source={{uri: 'https://upload.wikimedia.org/wikipedia/commons/f/f0/Everest_North_Face_toward_Base_Camp_Tibet_Luca_Galuzzi_2006_edit_1.jpg'}} style={{ resizeMode: 'cover', width: '100%', height: '100%' }}/>*/}
                                        <Image
                                            source={{uri: itemSub.Image ? itemSub.Image : itemSub.image}}
                                            style={{
                                                resizeMode: 'cover',
                                                width: '100%',
                                                height: '100%'
                                            }}/>

                                        {/*   <FastImage
                                        onLoad={(e)=>{}}
                                        onError={(e)=>{}}

                                        onLoadEnd={(e) => {


                                        }
                                        }
                                      //  source={{uri: itemSub.Image ? itemSub.Image : itemSub.image}}
                                        source={{uri: "https://partak.satiaisp.com/images/service_group/sg_37.png"}}
                                        //resizeMode="stretch"
                                        style={[{}, {


                                            // position: 'absolute',
                                            //  bottom: 0,
                                            width: "100%",
                                            height:  "100%",
                                            //  tintColor: Colors.white
                                            // alignSelf: 'center',
                                        }]}/>*/}
                                    </View>
                                    <View style={{width: moderateScale(3)}}/>
                                    <View style={{flex: 1}}>
                                        <HMTextView
                                            numberOfLines={2}
                                            type={"bold"}
                                            // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                            text={itemSub.Label}
                                            style={{
                                                fontSize: moderateScale(14),

                                                color: Colors.blackLight,
                                                flexWrap: 'wrap'
                                                //  marginTop: moderateScale(4),
                                                //  textAlign: "right",
                                            }}/>
                                    </View>
                                </View>
                                <View style={{
                                    flex: 1,
                                    flexDirection: 'row',
                                    paddingHorizontal: moderateScale(4)
                                }}>
                                    <View style={{flex: .5, flexDirection: 'row'}}>

                                        <HMTextView
                                            numberOfLines={2}
                                            type={"bold"}
                                            // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                            text={"سرعتMbps : "}
                                            style={{
                                                fontSize: moderateScale(14),

                                                color: Colors.colorDark,
                                                //  marginTop: moderateScale(4),
                                                //  textAlign: "right",
                                            }}/>
                                        <HMTextView
                                            numberOfLines={2}
                                            type={"bold"}
                                            // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                            text={itemSub.SpeedName}
                                            style={{
                                                fontSize: moderateScale(14),

                                                color: Colors.blackLight,
                                                //  marginTop: moderateScale(4),
                                                //  textAlign: "right",
                                            }}/>
                                    </View>
                                    <View style={{flex: .5, flexDirection: 'row'}}>
                                        {/*<HMTextView*/}
                                        {/*numberOfLines={2}*/}
                                        {/*type={"bold"}*/}
                                        {/*// text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}*/}
                                        {/*text={"ترافیک بین المل در ماه : "}*/}
                                        {/*style={{*/}
                                        {/*fontSize: moderateScale(12),*/}

                                        {/*color: Colors.colorDark,*/}
                                        {/*//  marginTop: moderateScale(4),*/}
                                        {/*//  textAlign: "right",*/}
                                        {/*}}/>*/}
                                        {/*<HMTextView*/}
                                        {/*numberOfLines={2}*/}
                                        {/*type={"bold"}*/}
                                        {/*// text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}*/}
                                        {/*text={itemSub.Internationalـtraffic}*/}
                                        {/*style={{*/}
                                        {/*fontSize: moderateScale(12),*/}

                                        {/*color: Colors.blackLight,*/}
                                        {/*//  marginTop: moderateScale(4),*/}
                                        {/*//  textAlign: "right",*/}
                                        {/*}}/>*/}
                                    </View>
                                </View>

                                {/*////*/}
                                <FlatList
                                    style={{marginTop: moderateScale(1)}}
                                    // ItemSeparatorComponent={
                                    //     <View style={{
                                    //         width: '100%',
                                    //         height: moderateScale(1),
                                    //         backgroundColor: '#4f4f4f'
                                    //     }}/>
                                    // }
                                    // data={comment === null || !comment ? [] : comment}
                                    listKey={(item, index) => 'D' + index.toString()}
                                    keyExtractor={(item, index) => index.toString()}
                                    numColumns={2}
                                    //type => 1=  , 2= , 3= , 4= ,
                                    data={itemSub.list}
                                    //data={list}
                                    renderItem={({item: itemSubChild, index: indexSubChild}) => {


                                        return <TouchableOpacity
                                            disabled={this.state.ServicesReserve}
                                            style={{
                                                width: "49%",
                                                //  height: moderateScale(68),
                                                borderRadius: moderateScale(6),
                                                borderColor: this.state.ServicesReserve ? Colors.red : Colors.green,
                                                //  backgroundColor: Colors.white,
                                                borderWidth: moderateScale(1),
                                                overflow: 'hidden',
                                                margin: moderateScale(2),
                                                alignItems: 'center',
                                                paddingHorizontal: moderateScale(6)
                                            }}
                                            onPress={() => {
                                                // /*      if (checkScreenRegister) {
                                                //           this.props.route.params.funcSetServiceType(itemSubChild);
                                                //           NavigationService.Pop();
                                                //       }
                                                //       else*/
                                                // NavigationService.navigateParams(MoarefRef ? "PaySatiaScreen_Root" : "PaySatiaScreen", {
                                                //     item: itemSubChild,
                                                //     checkScreenRegister: checkScreenRegister,
                                                //     Phone: Phone,
                                                //     funcSetServiceType: this.props.route && this.props.route.params ? this.props.route.params.funcSetServiceType : this.props.itemExtra.funcSetServiceType
                                                //
                                                // })
                                                //
                                                if (checkScreenRegister) {
                                                    (this.props.route && this.props.route.params ? this.props.route.params.funcSetServiceType : this.props.itemExtra.funcSetServiceType)(itemSubChild);
                                                    // NavigationService.Pop();
                                                }
                                                else
                                                    NavigationService.navigateParams("PaySatiaScreen", {
                                                        item: itemSubChild,
                                                        checkScreenRegister: checkScreenRegister,
                                                        Phone: Phone,
                                                        funcSetServiceType: this.props.route && this.props.route.params ? this.props.route.params.funcSetServiceType : this.props.itemExtra.funcSetServiceType

                                                    })
                                            }}
                                        >
                                            <View
                                                style={{
                                                    width: '100%',
                                                    flexDirection: 'row',
                                                    justifyContent: 'space-between',
                                                    //alignItems: 'center',
                                                }}

                                            >
                                                <HMTextView
                                                    numberOfLines={2}
                                                    type={"bold"}
                                                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                    text={itemSubChild.Duration}
                                                    style={{
                                                        fontSize: moderateScale(13),

                                                        color: Colors.colorDarkText,
                                                        //  marginTop: moderateScale(4),
                                                        //  textAlign: "right",
                                                    }}/>
                                                <View style={{}}>
                                                    <HMTextView
                                                        cammas
                                                        // numberOfLines={2}
                                                        type={"bold"}
                                                        text={parseInt((itemSubChild.Price / unitValue)) + " " + unit}
                                                        style={[{
                                                            fontSize: moderateScale(13),

                                                            color: Colors.blackLight,
                                                            marginHorizontal: moderateScale(2),
                                                            //  marginTop: moderateScale(4),
                                                            //  textAlign: "right",


                                                        }, !itemSubChild.Discount || itemSubChild.Discount === 0 ? {} : {
                                                            textDecorationLine: ('line-through'),
                                                            textDecorationColor: Colors.red,
                                                        }]}/>
                                                    {
                                                        !itemSubChild.Discount || itemSubChild.Discount === 0 ?
                                                            null
                                                            :
                                                            <HMTextView
                                                                cammas
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                // text={parseInt(((itemSubChild.Price - itemSubChild.Discount) / unitValue)) + " " + unit}
                                                                text={parseInt(((itemSubChild.Price - itemSubChild.Discount) / unitValue)) + " " + unit}
                                                                style={{
                                                                    fontSize: moderateScale(14),

                                                                    color: Colors.green,
                                                                    marginHorizontal: moderateScale(2),
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                }}/>
                                                    }
                                                    {/*  <HMTextView
                                                    cammas
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                    text={itemSubChild.Price}
                                                    style={{
                                                        fontSize: moderateScale(12),

                                                        color: Colors.green,
                                                        //  marginTop: moderateScale(4),
                                                        //  textAlign: "right",
                                                    }}/>
                                                <HMTextView
                                                    //  numberOfLines={2}
                                                    type={"bold"}
                                                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                    text={unit}
                                                    style={{
                                                        fontSize: moderateScale(9),

                                                        color: Colors.green,
                                                        //  marginTop: moderateScale(4),
                                                        //  textAlign: "right",
                                                    }}/>*/}
                                                </View>

                                                <HMIcon type={"FontAwesome"} name={"shopping-cart"}
                                                        style={{
                                                            fontSize: moderateScale(17),
                                                            color: this.state.ServicesReserve ? Colors.red : Colors.green,
                                                            textAlign: "center",
                                                            marginTop: moderateScale(2)
                                                            //  padding: moderateScale(2),

                                                        }}/>
                                            </View>


                                            <HMTextView
                                                numberOfLines={1}
                                                type={"bold"}
                                                // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                text={`${itemSubChild.CreditGig / (itemSubChild.FupToInternet ? itemSubChild.FupToInternet : 4)} گیگ ترافیک بین الملل `}
                                                style={{
                                                    fontSize: moderateScale(12),

                                                    color: Colors.colorDarkText,
                                                    alignSelf: 'center'
                                                    //  marginTop: moderateScale(4),
                                                    //  textAlign: "right",
                                                }}/>
                                        </TouchableOpacity>

                                    }}


                                />

                            </View>

                        </View>

                    }}


                />
                {/*////*/}

            </View>
        </View>
    }


}

const mapStateToProps = state => {
    return {

        token: state.reducerSplashSatiaScreen.token,
        DataSplashSatiaScreen: state.reducerSplashSatiaScreen,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        //  callServiceCommentScreen: (url, params, type, typeConnection, page, item_count, token) => dispatch(callWebserviceComment(url, params, type, typeConnection, page, item_count, token)),
        //   callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};
export default connect(mapStateToProps,
    mapDispatchToProps)(ListServiceSatiaScreen);
